import React, { memo, useCallback } from 'react';
import uniqid from 'uniqid';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import BookingFormStore from 'Stores/BookingFormStore';
import BookingDiscountCode from 'Components/Front/Booking/BookingDiscountCode';
import BookingLegalFields from 'Components/Front/Booking/BookingLegalFields';
import BookingUserFields from 'Components/Front/Booking/BookingUserFields';
import BookingFlowStatus from 'Components/Front/Booking/BookingFlowStatus';
import TextInput from 'Components/Forms/Elements/TextInput';
import Loader from 'Pure/Loader';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
const {
  app
} = window;
const fields = ['user[password]', 'password-verification'];
function handleClickShowPassword(e) {
  BookingFormStore.update(function (store) {
    store.showPassword = !store.showPassword;
  });
}
export default memo(function BookingRegistration({
  ...props
}) {
  const create_account = BookingFormStore.useState(s => s.create_account);
  const show_password = BookingFormStore.useState(s => s.showPassword);
  const is__free = BookingFormStore.useState(s => !(s.grand_total > 0));
  const errors = BookingFormStore.useState(s => s.status_messages || {});
  const step = BookingFormStore.useState(s => s.step);
  const redirecting = BookingFormStore.useState(s => s.redirecting === true);
  const submitting = BookingFormStore.useState(s => s.submitting === true);
  const state_is_customer = BookingFormStore.useState(s => s.is_customer);
  const is__company_employee = (app.state.session?.user?.roles || []).includes('company_employee');
  const is__customer = state_is_customer || app.state.session.user?.roles?.includes?.('customer');
  const state = BookingFormStore.useState(function (store) {
    return fields.reduce(function (state, field) {
      return {
        ...state,
        [field]: store[field]
      };
    }, {});
  });
  const handleChange = useCallback(function ({
    e,
    value,
    name
  }) {
    BookingFormStore.update(function (store) {
      store[name] = value;
      store.status_messages[name] = undefined;
      delete store.status_messages[name];
      ['E_CODE', 'info', 'error', 'warning'].forEach(field => store[field] = undefined);
    });
  }, []);
  const preventDefault = useCallback(function (e) {
    e.preventDefault();
  }, []);
  const validate = useCallback(function (e) {
    e?.preventDefault?.();
    BookingFormStore.update(function (store) {
      store.submit_form_id = uniqid();
    });
  }, []);
  const modifiers = ['reservation'].concat(props['white-label-booking'] ? ['white-label-booking'] : []);
  if (is__customer || step !== 1) return null;
  if (create_account !== true) return null;
  if (is__company_employee) return null;
  const submit_loader = submitting || redirecting ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['white', 'bg-primary']
  }) : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
    className: "c-booking-auth__subtitle"
  }, "S'inscrire avec myWO"), /*#__PURE__*/React.createElement("form", {
    action: action('CreateBooking'),
    method: "POST",
    className: "c-booking-auth__form",
    onSubmit: validate
  }, /*#__PURE__*/React.createElement(BookingUserFields, {
    "white-label-booking": props['white-label-booking']
  }), /*#__PURE__*/React.createElement(TextInput, {
    required: true,
    onChange: handleChange,
    value: state['user[password]'],
    name: "user[password]",
    type: show_password ? 'text' : 'password',
    label: "Mot de passe (12 carac. min.)",
    className: bemit('c-form-element', modifiers),
    variant: "outlined",
    autocomplete: "new-password",
    suffix: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Voir le mot de passe",
      onClick: handleClickShowPassword,
      onMouseDown: preventDefault,
      edge: "end"
    }, show_password ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null))),
    status: errors
  }), /*#__PURE__*/React.createElement(TextInput, {
    required: true,
    onChange: handleChange,
    value: state['password-verification'],
    name: "password-verification",
    type: show_password ? 'text' : 'password',
    label: "Retapez votre mot de passe (12 carac. min.)",
    className: bemit('c-form-element', modifiers),
    variant: "outlined",
    autocomplete: "new-password",
    suffix: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Voir le mot de passe",
      onMouseDown: preventDefault,
      onClick: handleClickShowPassword,
      edge: "end"
    }, show_password ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null))),
    status: errors
  }), /*#__PURE__*/React.createElement(BookingLegalFields, {
    bemit: props.bemit,
    "with-newsletter": true,
    "white-label-booking": props['white-label-booking']
  }), /*#__PURE__*/React.createElement(BookingDiscountCode, {
    space: props.space
  }), /*#__PURE__*/React.createElement(BookingFlowStatus, {
    "white-label-booking": props['white-label-booking']
  }), /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['primary', 'round']) + ' u-block u-margin-top-25 u-margin-left-auto u-margin-right-auto',
    type: "submit"
  }, is__free ? 'Réserver' : 'Valider la réservation et procéder au paiement', submit_loader)));
});
